import React from "react";
import WeaInputNormal from "../base/wea-input-normal";
import WeaWfInput from "../base/wea-wf-input";
import WeaInputLocale from "../wea-input-locale/index";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";

// const WeaInputLocale = InputLocale.WeaInputLocale;

class main extends React.Component {
  static defaultProps = {
    inputType: "NORMAl"
  };
  static propTypes = {
    inputType: React.PropTypes.string
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const isMulti = window.localStorage.getItem("activeLanguageIds");
    const inputType = this.props.inputType.toUpperCase();
    if (inputType === "MULTILANG") {
      if (isMulti === null) {
        WeaTools.callApi(
          "/api/system/language/base/getActiveLanguage",
          "GET"
        ).then(res => {
          if (res.activeLanguageIds)
            window.localStorage.setItem(
              "activeLanguageIds",
              JSON.stringify(res.activeLanguageIds)
            );
        });
      }
    }
  }

  setValue(v = "") {
    this.refs.inputNormal && this.refs.inputNormal.setValue(v);
  }
  render() {
    const { props } = this;
    let isMulti = window.localStorage.getItem("activeLanguageIds") || "[7]";
    const inputType = props.inputType.toUpperCase();
    let otherProps = {};
    try {
      isMulti = JSON.parse(isMulti);
    } catch (error) {
      isMulti = [];
      console.error("获取多语言配置信息失败", error);
    }
    if (inputType === "FORM") {
      return <WeaWfInput {...props} />;
    }
    if (inputType === "MULTILANG" && isMulti.length > 1) {
      return <WeaInputLocale {...props} />;
    }
    if (
      props.type &&
      props.type.toUpperCase() === "PASSWORD" &&
      (props.viewAttr === 1 || props.viewAttr === "1")
    ) {
      // 当密码项只读时，用‘*’替换文本内容
      otherProps = {
        ...otherProps,
        value: "*".repeat(props.value ? props.value.length : 0)
      };
    }
    return <WeaInputNormal ref="inputNormal" {...props} {...otherProps} />;
  }
}

const Com = middleware(main, "WeaInput");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input/index.js